import Skeleton from 'react-loading-skeleton';

import styles from '../../LikeCard.module.scss';

export const LikeCardSkeleton = () => {
  return (
    <div className={styles.likeCardSkeleton} data-test-id="like-card-skeleton">
      <Skeleton height="100%" className={styles.skeleton} />
    </div>
  );
};
